import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Observable, Subject, throwError } from 'rxjs';
import { catchError, filter, map, switchMap, take, takeUntil, withLatestFrom } from 'rxjs/operators';

import { AlertController, NavController } from '@ionic/angular';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { AlertService } from '@core/services/alert/alert.service';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { OnlineCreditService } from '@core/services/online-credit/online-credit.service';
import { StepManagerService } from '@core/services/online-credit/step-manager.service';

import { LifecycleHookLogs } from '@shared/decorators/lifecycle-hook-logs/lifecycle-hook-logs.decorator';
import { NetworkService } from '@shared/services/network.service';

import { Steps } from '../models/step.model';
import { StoreService } from '../store/store.service';
import { SigningOfAgreementsStepService } from './signing-of-agreements-step.service';

@LifecycleHookLogs()
@UntilDestroy()
@Component({
  selector: 'app-signing-of-agreements-step',
  templateUrl: 'signing-of-agreements-step.page.html',
  styleUrls: ['./signing-of-agreements-step.page.scss', '../new-credit.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SigningOfAgreementsStepPage implements OnInit, OnDestroy {
  title: string = 'Подписание согласий';
  subtitle: string = '';

  public loaded$: Observable<boolean>;
  public formGroup: FormGroup;

  public agreeCheckRating = {
    title: 'Согласие на получение информации из бюро кредитных историй',
    text: `<h4>Бюро кредитных историй</h4>
    <p>Я даю свое согласие на получение моей кредитной истории (кредитных отчетов) из любых Бюро кредитных историй
    в целях заключения и исполнения договора и/или проверки благонадежности.</p>`
  };

  public agreeUsePersonalInfo = {
    title:
      'Согласие на обработку персональных данных и получение Сведений о состоянии индивидуального лицевого счета застрахованного лица'
  };

  agreementsPfrText$ = this.onlineCreditService.agreementsDictionary$.pipe(
    map((dictionary: any) => {
      const agreement = dictionary.find((item) => item.code === 'pfrAgreement');
      return `<h4>Согласия в ПФР</h4>
               <p>${agreement.description}</p>`;
    })
  );

  // private alertCtrl: AlertController;
  // private navCtrl: NavController;
  private destroyed$ = new Subject();

  constructor(
    private onlineCreditService: OnlineCreditService,
    private stepManagerService: StepManagerService,
    private signAgreementsService: SigningOfAgreementsStepService,
    private fb: FormBuilder,
    private store: StoreService,
    private alertService: AlertService,
    private router: Router,
    private navigationService: NavigationService,
    private networkService: NetworkService
    // private readonly injector: Injector,
  ) {
    this.loaded$ = this.stepManagerService.stepLoaded$;
    // this.onlineCreditService = this.injector.get(OnlineCreditService);
    // this.stepManagerService = this.injector.get(StepManagerService);
    // this.signAgreementsService = this.injector.get(SigningOfAgreementsStepService);
    // this.fb = this.injector.get(FormBuilder);
    // this.store = this.injector.get(StoreService);
    // this.alertCtrl = this.injector.get(AlertController);
    // this.navCtrl = this.injector.get(NavController);
    // this.loaded$ = this.stepManagerService.stepLoaded$;
  }

  ngOnInit() {
    this.formGroup = this.fb.group({
      agreementBki: [false, [Validators.required, Validators.requiredTrue]],
      agreementPfr: [false, [Validators.required, Validators.requiredTrue]]
    });
    setTimeout(() => {
      this.stepManagerService.setStepLoaded(true);
    }, 500);
  }

  ionViewWillEnter() {}

  ngOnDestroy() {
    this.destroyed$.next(null);
    this.destroyed$.complete();
  }

  ionViewWillLeave() {}

  async confirm() {
    await this.networkService.getStatus().then((status) => {
      if (!status) {
        this.alertService.showInfoAlert('Отсутствует подключение к интернету!');
        return;
      }
      const application = this.store.value.application;
      const docIds = [application.pensionFundConsents[0].id, application.creditBureauConsents[0].id];

      this.signAgreementsService
        .signAgreements(docIds)
        .pipe(
          switchMap(() => this.onlineCreditService.foundPension(application.id)),
          switchMap(() =>
            this.onlineCreditService.sendApplicationData({
              ...this.store.value.application,
              consentSign: true
            })
          ),
          untilDestroyed(this)
        )
        .subscribe(
          (application) => {
            this.store.updateApplication(application);
            // this.stepManagerService.changeStep(Steps.personalData, {fillAdditionalPersonalData: true})
            this.stepManagerService.setStepLoaded(false);
            void this.navigationService.push('/new-product/credit/' + Steps.personalData, {
              replaceUrl: true,
              queryParams: { fillAdditionalPersonalData: true }
            });
          },
          (error) => {
            const message = error.errorText || (error.error && error.error.errorText);
            this.alertService.showInfoAlert(message || error);
          }
        );

      // this.onlineCreditService.sendApplicationData({...this.store.value.application, consentSign: true}).pipe(untilDestroyed(this)).subscribe(
      //   (res) => {
      //     this.store.updateApplication(res);
      //     this.stepManagerService.changeStep(Steps.personalData, {fillAdditionalPersonalData: true})
      //   },
      //   (err) => {
      //     this.stepManagerService.showErrorStepAlert(err);
      //   }
      // )
    });
  }

  goBack() {
    this.stepManagerService.setStepLoaded(false);
    this.stepManagerService.changeStep(Steps.accountConfirmation);
  }

  abort() {
    this.stepManagerService.showAbortAlert();
  }
}
